import ModalDescription from './ModalDescription';

export default ModalDescription;
